<template>
  <transition name="slide-up">
    <div v-if="typingUsers.length > 0" class="typing-indicator">
      <div class="typing-content">
        <div class="typing-animation">
          <div class="typing-dots">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
        </div>
        <div class="typing-text">
          <v-icon size="14" class="typing-icon">mdi-pencil</v-icon>
          <span>{{ getTypingText() }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TypingIndicator',
  props: {
    typingUsers: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getTypingText() {
      const count = this.typingUsers.length
      
      if (count === 0) return ''
      if (count === 1) return `${this.getUserName(this.typingUsers[0])} is typing...`
      if (count === 2) return `${this.getUserName(this.typingUsers[0])} and ${this.getUserName(this.typingUsers[1])} are typing...`
      if (count === 3) return `${this.getUserName(this.typingUsers[0])}, ${this.getUserName(this.typingUsers[1])} and ${this.getUserName(this.typingUsers[2])} are typing...`
      
      return `${count} people are typing...`
    },

    getUserName(userId) {
      // This should get user data from store/props
      return `User ${userId.substring(0, 8)}`
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../views/css/styles.scss';

.typing-indicator {
  padding: 12px 24px;
  background: linear-gradient(135deg, rgba(0, 123, 255, 0.05), rgba(0, 86, 179, 0.05));
  border-top: 1px solid rgba(0, 123, 255, 0.2);
  border-left: 3px solid #007bff;
  animation: slideIn 0.3s ease;
  border-radius: 0 0 0px 0px!important;
}

.typing-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.typing-animation {
  background: rgba(0, 123, 255, 0.1);
  border: 1px solid rgba(0, 123, 255, 0.3);
  border-radius: 16px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
}

.typing-dots {
  display: flex;
  gap: 4px;
  align-items: center;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, #007bff, #0056b3);
  animation: typing 1.4s infinite ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.3);
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

.dot:nth-child(3) {
  animation-delay: 0s;
}

.typing-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  display: flex;
  align-items: center;
  gap: 6px;
  animation: fadeIn 0.3s ease;
}

.typing-icon {
  color: #007bff !important;
  animation: wiggle 1s infinite ease-in-out;
}

/* Animations */
@keyframes typing {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes wiggle {
  0%, 100% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-5deg);
  }
  75% {
    transform: rotate(5deg);
  }
}

/* Transition Classes */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Responsive */
@media (max-width: 768px) {
  .typing-indicator {
    padding: 10px 20px;
  }

  .typing-text {
    font-size: 13px;
  }

  .dot {
    width: 5px;
    height: 5px;
  }

  .typing-animation {
    padding: 6px 10px;
  }
}

/* Vuetify Overrides */
:deep(.v-icon) {
  color: inherit !important;
}
</style>